import { Color } from "@tiptap/extension-color";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import ListItem from "@tiptap/extension-list-item";
import Subscript from "@tiptap/extension-subscript";
import Superscript from "@tiptap/extension-superscript";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import TextStyle from "@tiptap/extension-text-style";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";

export const TipTapExtensions = [
	Color.configure({ types: [TextStyle.name, ListItem.name] }),
	TextStyle,
	Subscript,
	Superscript,
	StarterKit.configure({
		bulletList: {
			keepMarks: true,
			keepAttributes: false, // TODO : Making this as `false` because marks are not preserved when I try to preserve attrs, awaiting a bit of help
		},
		orderedList: {
			keepMarks: true,
			keepAttributes: false, // TODO : Making this as `false` because marks are not preserved when I try to preserve attrs, awaiting a bit of help
		},
	}),
	Underline,
	Image.configure({
		inline: true,
	}),
	// If we need to add functionality to handle paste and drop events for images
	// 	// We can use the following code to handle paste and drop events for images
	// 	// This is commented out for now because we need to figure out how to upload the image
	// .extend({
	// 	addProseMirrorPlugins() {
	// 		return [
	// 		  new Plugin({
	// 			props: {
	// 			  handleDOMEvents: {
	// 				drop(view, event) {
	// 				  const hasFiles =
	// 					event.dataTransfer &&
	// 					event.dataTransfer.files &&
	// 					event.dataTransfer.files.length

	// 				  if (!hasFiles) {
	// 					return
	// 				  }

	// 				  const images = Array.from(event.dataTransfer.files).filter(file =>
	// 					/image/i.test(file.type)
	// 				  )

	// 				  if (images.length === 0) {
	// 					return
	// 				  }

	// 				  event.preventDefault()

	// 				  const { schema } = view.state
	// 				  const coordinates = view.posAtCoords({
	// 					left: event.clientX,
	// 					top: event.clientY
	// 				  })

	// 				  images.forEach(image => {
	// 					const reader = new FileReader()

	// 					reader.onload = readerEvent => {
	// 					  const node = schema.nodes.image.create({
	// 						src: readerEvent.target.result
	// 					  })
	// 					  const transaction = view.state.tr.insert(
	// 						coordinates.pos,
	// 						node
	// 					  )
	// 					  view.dispatch(transaction)
	// 					}
	// 					reader.readAsDataURL(image)
	// 				  })
	// 				},
	// 				paste(view, event) {
	// 				  const hasFiles =
	// 					event.clipboardData &&
	// 					event.clipboardData.files &&
	// 					event.clipboardData.files.length

	// 				  if (!hasFiles) {
	// 					return
	// 				  }

	// 				  const images = Array.from(
	// 					event.clipboardData.files
	// 				  ).filter(file => /image/i.test(file.type))

	// 				  if (images.length === 0) {
	// 					return
	// 				  }

	// 				  event.preventDefault()

	// 				  const { schema } = view.state

	// 				  images.forEach(image => {
	// 					const reader = new FileReader()

	// 					reader.onload = readerEvent => {
	// 					  const node = schema.nodes.image.create({
	// 						src: readerEvent.target.result
	// 					  })
	// 					  const transaction = view.state.tr.replaceSelectionWith(node)
	// 					  view.dispatch(transaction)
	// 					}
	// 					reader.readAsDataURL(image)
	// 				  })
	// 				}
	// 			  }
	// 			}
	// 		  })
	// 		]
	// 	  },
	// 	}),
	Table,
	TableRow,
	TableHeader,
	TableCell,
	Link.configure({
		openOnClick: false,
		autolink: false,
		defaultProtocol: "https",
		protocols: ["http", "https"],
		isAllowedUri: (url, ctx) => {
			try {
				// construct URL
				const parsedUrl = url.includes(":")
					? new URL(url)
					: new URL(`${ctx.defaultProtocol}://${url}`);

				// use default validation
				if (!ctx.defaultValidate(parsedUrl.href)) {
					return false;
				}

				// disallowed protocols
				const disallowedProtocols = ["ftp", "file", "mailto"];
				const protocol = parsedUrl.protocol.replace(":", "");

				if (disallowedProtocols.includes(protocol)) {
					return false;
				}

				// only allow protocols specified in ctx.protocols
				const allowedProtocols = ctx.protocols.map((p) =>
					typeof p === "string" ? p : p.scheme,
				);

				if (!allowedProtocols.includes(protocol)) {
					return false;
				}

				// disallowed domains
				const disallowedDomains = [
					"example-phishing.com",
					"malicious-site.net",
				];
				const domain = parsedUrl.hostname;

				if (disallowedDomains.includes(domain)) {
					return false;
				}

				// all checks have passed
				return true;
			} catch {
				return false;
			}
		},
		shouldAutoLink: (url) => {
			try {
				// construct URL
				const parsedUrl = url.includes(":")
					? new URL(url)
					: new URL(`https://${url}`);

				// only auto-link if the domain is not in the disallowed list
				const disallowedDomains = [
					"example-no-autolink.com",
					"another-no-autolink.com",
				];
				const domain = parsedUrl.hostname;

				return !disallowedDomains.includes(domain);
			} catch {
				return false;
			}
		},
	}),
];
